import styled from 'styled-components'

export const VideoOverlay = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`

VideoOverlay.displayName = 'VideoOverlay'
